const readShareH5BaseLink = (raw: string | undefined): string => {
  if (!raw || !raw.trim()) {
    return '';
  }
  try {
    const parsed = JSON.parse(raw) as { shareH5BaseLink?: unknown };
    return typeof parsed.shareH5BaseLink === 'string'
      ? parsed.shareH5BaseLink.trim()
      : '';
  } catch {
    return '';
  }
};

export const buildSharePageUrl = (
  configs: Map<string, string>,
  path: string
): string => {
  const domain = readShareH5BaseLink(configs.get('sharePageDomain')).replace(
    /\/+$/,
    ''
  );
  const segment = path.replace(/^\/+/, '');
  if (!domain) {
    return segment ? `/${segment}` : '/';
  }
  return `${domain}/${segment}`;
};
